/**
 * @deprecated This function is deprecated. Use useApi or useSearch instead.
 * @param {*} fn - http request function
 * @param  {...any} args
 * @returns The response of the request or an error
 */
export const withAsync = async (fn, ...args) => {
  try {
    const response = await fn(...args);
    return {
      response,
      error: null,
    };
  } catch (error) {
    return {
      response: null,
      error,
    };
  }
};
